export const STATIC_CONTENT_ORIGIN = 'https://static.wunderweg.com';

export const toProxyUrl = (u) => u.replace(STATIC_CONTENT_ORIGIN, '/g');

export const toGameDocumentUrl = (u) => {
  const out = toProxyUrl(u);
  const [, path = out, query = '', hash = ''] = out.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/) || [];

  if (path.endsWith('/index.html')) {
    return out;
  }

  if (path.endsWith('/')) {
    return `${path}index.html${query}${hash}`;
  }

  return `${path}/index.html${query}${hash}`;
};
